// extracted by mini-css-extract-plugin
var _1 = "DateText_dateHoverable__UdSgU";
var _2 = "DateText_wrapper__JjvbU";
export { _1 as "dateHoverable", _2 as "wrapper" }
